export const containsAllWords = (inputString: string, wordsArray: string[]): boolean => {
  inputString = inputString.toLowerCase();

  for (const word of wordsArray) {
    const lowercaseWord = word.toLowerCase();

    if (!inputString.includes(lowercaseWord)) {
      return false;
    }
  }

  return true;
};
